import { Controller } from "@hotwired/stimulus"
import { appliesToForm, fieldGroup, isFieldFilled, isFieldShown } from "../../src/shared/helpers/form_field_state"

// Ticks the activation requirements off while the admin fills the form, and
// scrolls to a requirement's field when its item is clicked. The server stays
// the source of truth: this only mirrors "is the field filled in?".
// Fields hidden by the form (e.g. new-user fields when an existing account is
// picked), and items that do not apply (`appliesToForm`), drop out of the list.
export default class extends Controller {
  static targets = ["item", "count", "total", "progress", "bar"]
  static classes = ["done"]

  connect () {
    this.form = this.element.closest("form")
    if (!this.form) return

    this.refresh = this.refresh.bind(this)
    this.events = ["input", "change", "click"]
    this.events.forEach((event) => this.form.addEventListener(event, this.refresh))
    this.refresh()
  }

  disconnect () {
    this.events?.forEach((event) => this.form.removeEventListener(event, this.refresh))
  }

  refresh () {
    let done = 0
    let total = 0

    this.itemTargets.forEach((item) => {
      const group = fieldGroup(this.form, item.dataset.fieldId)
      if (!group) return

      const shown = appliesToForm(this.form, item) && isFieldShown(group)
      item.closest("li").hidden = !shown
      if (!shown) return

      const filled = isFieldFilled(group)
      item.classList.toggle(this.doneClass, filled)
      total += 1
      if (filled) done += 1
    })

    if (this.hasCountTarget) this.countTarget.textContent = done
    if (this.hasTotalTarget) this.totalTarget.textContent = total
    if (this.hasProgressTarget) {
      this.progressTarget.setAttribute("aria-valuenow", done)
      this.progressTarget.setAttribute("aria-valuemax", total)
    }
    if (this.hasBarTarget) {
      this.barTarget.style.width = `${total ? Math.round(done * 100 / total) : 0}%`
      this.barTarget.classList.toggle("bg-success", total > 0 && done === total)
    }
  }

  // `jump` lets a surrounding section menu show the field's section first.
  jump ({ params: { fieldId } }) {
    const group = fieldGroup(this.form, fieldId)
    if (!group) return

    this.dispatch("jump", { detail: { element: group } })

    const details = group.closest("details")
    if (details) details.open = true

    group.scrollIntoView({ behavior: "smooth", block: "center" })
    group.querySelector("input:not([type=hidden]), select, textarea")?.focus({ preventScroll: true })
  }
}
